import { Box, Button, Container, Grid, Radio, styled } from "@mui/material";

const modalStyle = {
    position: 'absolute',
    top: '18%',
    left: '15%',
    width: '70%',
    bgcolor: 'background.paper',
    textAlign: 'center',
    borderRadius: '15px',
};

const ModalLabel = styled(Box)(() => ({
    backgroundColor: '#41DBCE',
    fontSize: '1.3rem',
    color: '#FFFFFF',
    height: '2.2rem',
    paddingTop: '0.5rem',
    borderRadius: '15px 15px 0 0',
    textAlign: 'left',
    paddingLeft: '1rem',
    boxSizing: 'content-box'
}));

const CheckBoxContainer = styled(Container)(() => ({
    overflowY: 'scroll',
    width: '100%',
    height: '20rem',
    textAlign: 'left',
    marginTop: '2%',
    border: '2px solid #dcdcdc',
}));

const CancelButton = styled(Button)(() => ({
    backgroundColor: '#BFBFBF',
    color: '#000000',
    textAlign: 'center',
    fontSize: '1rem',
    fontWeight: 'bold',
    height: '2.5rem',
    width: '8rem',
    borderRadius: '100rem'
}));

const OkButton = styled(Button)(() => ({
    backgroundColor: '#01CFBE',
    color: '#FFFFFF',
    textAlign: 'center',
    fontSize: '1rem',
    fontWeight: 'bold',
    height: '2.5rem',
    width: '5rem',
    borderRadius: '100rem',
    marginLeft: '1rem',
    marginRight: '-10rem'
}));

const TextFieldLabel = styled(Grid)(() => ({
    backgroundColor: '#595959',
    color: '#FFFFFF',
    display: 'flex',
    paddingLeft: '3%',
    marginRight: '1%',
    alignItems: 'center',
}));

const TextFieldForm = styled(Grid)(() => ({
    backgroundColor: '#FFFFFF',
}));

const OperatorRadio = styled(Radio)(() => ({
    color: '#41DBCE',
    '&.Mui-checked': {
        color: '#41DBCE',
    },
}));

export { modalStyle, ModalLabel, CheckBoxContainer, CancelButton, OkButton, TextFieldLabel, TextFieldForm, OperatorRadio }
